import { PaletteColor } from '../../components/ThemeProvider';

export const HrWeight = {
	Normal: 'Normal',
	Heavy: 'Heavy',
} as const;
export type HrWeightType = (typeof HrWeight)[keyof typeof HrWeight];

export interface HrProps {
	weight?: HrWeightType;
	color?: PaletteColor;
	opacity?: number;
	className?: string;
}
